import reports from './reports';

const reportsActionCreators = {
  ...reports,
};

export default reportsActionCreators;
